import React from 'react';
import './FishingSection.css';

const FISHING_FEATURES = [
  'Legendary unsinkable construction and unmatched durability',
  'Maximum maneuverability for chasing a line',
  'Rod holders at every turn',
  'Spacious livewells and in-floor fishboxes for everything from bait to goliath catches',
  'Ample storage for all your tackle and supplies',
  'Ergonomic helms that provide views from every angle',
  'Advanced technology with Raymarine electronics, Seakeeper gyrostabilization and more',
];

function FeatureSection({ title, description, features, image, imageAlt, ctaText, ctaHref, reversed }) {
  return (
    <section className="fishing">
      <div className={`fishing__container ${reversed ? 'fishing__container--reversed' : ''}`}>
        {/* Image */}
        <div className="fishing__image-wrapper">
          <img
            src={image}
            alt={imageAlt}
            className="fishing__image"
          />
        </div>

        {/* Content */}
        <div className="fishing__content">
          <h2 className="fishing__title">{title}</h2>
          <p className="fishing__description">{description}</p>
          <ul className="fishing__features">
            {features.map((feature, i) => (
              <li key={i} className="fishing__feature-item">
                {feature}
              </li>
            ))}
          </ul>
          <a href={ctaHref} className="fishing__cta">
            {ctaText}
          </a>
        </div>
      </div>
    </section>
  );
}

function FishingSection() {
  return (
    <FeatureSection
      title="Fishing"
      description="There are no boats more ideally suited for fishing than Unimar. They perform beautifully offshore, inshore or on the lake, are incredibly safe, and have unmatched fishability. But just what makes a Whaler a great fishing boat?"
      features={FISHING_FEATURES}
      image="/unimar-boat-fishing.webp"
      imageAlt="Fisherman holding a rod and reel on the open water"
      ctaText="See Fishing Model"
      ctaHref="/models"
      reversed={false}
    />
  );
}

const FAMILY_FEATURES = [
  'Solid and strong to withstand even the farthest tows',
  'Ready-made for tender duty',
  'Reliable Mercury power to get you from the yacht to dinner with ease',
  'Simple and easy upkeep',
  'Stylish touches to catch the eye of every passerby',
  'Safe and secure – never worry about a thing',
];

function FishingSectionReversed() {
  return (
    <FeatureSection
      title="Relaxing with Family"
      description="Vestibulum sollicitudin est non turpis fringilla ultricies. In dictum ullamcorper leo ut dictum. Fusce sit amet posuere ante, a hendrerit eros. Aliquam quis fringilla mi. Quisque vel rutrum elit. Maecenas venenatis est purus, a fermentum dui faucibus at."
      features={FAMILY_FEATURES}
      image="/unimar-boat-family.webp"
      imageAlt="Family walking together on the beach looking at the ocean"
      ctaText="See Family Model"
      ctaHref="/models"
      reversed={true}
    />
  );
}

const CRUISING_FEATURES = [
  'Legendary unsinkable construction and unmatched durability',
  'Maximum maneuverability for chasing a line',
  'Rod holders at every turn',
  'Spacious livewells and in-floor fishboxes for everything from bait to goliath catches',
  'Ample storage for all your tackle and supplies',
  'Ergonomic helms that provide views from every angle',
];

function FishingSectionThird() {
  return (
    <FeatureSection
      title="Cruising"
      description="Vestibulum sollicitudin est non turpis fringilla ultricies. In dictum ullamcorper leo ut dictum. Fusce sit amet posuere ante, a hendrerit eros. Aliquam quis fringilla mi. Quisque vel rutrum elit. Maecenas venenatis est purus, a fermentum dui faucibus at."
      features={CRUISING_FEATURES}
      image="/unimar-boat-cruising.webp"
      imageAlt="Aerial view of a boat cruising on turquoise water"
      ctaText="See Cruising Model"
      ctaHref="/models"
      reversed={false}
    />
  );
}

export default FishingSection;
export { FishingSectionReversed, FishingSectionThird, FeatureSection };
